import { render, staticRenderFns } from "./showInfo.vue?vue&type=template&id=5575d025&scoped=true"
import script from "./showInfo.vue?vue&type=script&lang=js"
export * from "./showInfo.vue?vue&type=script&lang=js"
import style0 from "./showInfo.vue?vue&type=style&index=0&id=5575d025&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5575d025",
  null
  
)

export default component.exports